/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import LoadingIcon from 'components/loadingIcon/index';

export const FullPageLoader: React.FC = () => {
	return (
		<div css={loaderContainer}>
			<LoadingIcon size={60} />
		</div>
	);
};

const loaderContainer = css`
	height: 100vh;
	width: 100vw;
`;
